import { memo, useEffect, useState } from 'react';
import { IconButton, IconButtonStyles, Icons } from '@silverfort/sf-components';

interface Props {
    copyContent?: string;
}

const COPIED_RESET_TIME = 1000;

const CopyButton = memo(({ copyContent }: Props) => {
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setIsCopied(false);
            }, COPIED_RESET_TIME);
        }
    }, [isCopied]);

    const onCopyClicked = async () => {
        await navigator.clipboard.writeText(copyContent ?? '');
        setIsCopied(true);
    };

    return !isCopied ? (
        <IconButton icon={Icons.Copy} buttonStyle={IconButtonStyles.Secondary} onClick={onCopyClicked} />
    ) : (
        <div className="font-sf font-medium text-13 text-sf-gray-500">Copied!</div>
    );
});

export default CopyButton;
